<template>
  <div class="m-5">
    <div v-for="(order, index) in toPayOrders" :key="index">
      <v-row>
        <Avatars class="m-3" height="20px" :seed="order.userId" />
        <b>{{ getLocation(order.location).name }}</b>
      </v-row>

      <v-row class="d-flex" v-for="(product, indexproducts) in order.products" :key="indexproducts">
        <v-col cols="10" class="mt-2 ml-4">
          <v-row class="align-center">
            <v-col cols="6">{{ product.name }}</v-col>
            <v-col cols="4" class="d-flex justify-end">
              <v-chip
                v-for="(option, i) in product.options"
                :key="i"
                small
                outlined
                exact
                class="body-2 font-italic"
              >
                {{ option.name }}
                {{ localizedPrice(option.addedPrice) }}
              </v-chip>
            </v-col>
            <v-col cols="2" class="d-flex justify-end">{{ calculatePrice(product) }}€</v-col>
          </v-row>
          <span v-if="product.comment" class="body-2 font-italic">{{ product.comment }}</span>
        </v-col>
      </v-row>
    </div>
    <v-row justify="end">
      <b
        class="headline right-align"
      >{{ $t("Total: {totalPrice}", { totalPrice: localizedPrice(totalPrice) }) }}</b>
    </v-row>
  </div>
</template>

<script>
import Avatars from "@/views/dashboard/components/Avatars";

export default {
  components: { Avatars },
  props: ["toPayOrders"],
  computed: {
    totalPrice() {
      let price = 0;
      this.toPayOrders.forEach(order =>
        order.products.forEach(
          product => (price += this.calculatePrice(product))
        )
      );
      return price;
    }
  },

  methods: {
    calculatePrice(product) {
      let price = Number(product.price) ? Number(product.price) : 0;
      // console.log("precios");
      if (product.options) {
        product.options.forEach(option => (price += option.addedPrice));
      }
      return price;
    },
    getLocation(locationId) {
      // console.log("location");
      return this.$store.getters.locations.find(
        location => location.id === locationId
      );
    },
    localizedPrice(price) {
      return parseFloat(price).toFixed(2) + " €";
    }
  }
};
</script>

<style></style>
